export interface ILoader {
    load(load: boolean): void
}

export interface ILoaderFactory {
    create(loaderElement: any, elements: any, hideElement: any, settings: loaderSettings): ILoader;
}

export class loaderSettings {
    excludeAlreadyDisabled: boolean;
    disablableChildTags: string[];
}